import axios from 'axios';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

interface UploadFileSignedUrlParams {
	url: string;
	file: File;
	contentType: Blob['type'];
}

async function uploadFile(params: UploadFileSignedUrlParams) {
	const headers = {
		headers: {
			'Content-Type': params.contentType
		}
	};
	const data = await axios.put(params.url, params.file, headers);
	return data;
}

export const useUploadFileSignedUrl = () => {
	return useMutation({
		mutationFn: async (params: UploadFileSignedUrlParams) => uploadFile(params),
		onSuccess: () => {
			message.success(I18n.get('File uploaded successfully'));
		},
		onError: () => {
			message.error(I18n.get('Failed to upload file'));
		}
	});
};
